module.exports = __webpack_public_path__ + "static/img/role.0d642d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/tysdags/role.png
// module id = QS0P
// module chunks = 7